'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { Root as Root3, Trigger, Content as Content2, Arrow as Arrow2 } from './../../../external/@radix-ui/react-tooltip/dist/index.js';

const Tooltip = ({ asChild, children, content, open, side, sideOffset, className, }) => {
    return (jsxs(Root3, { open: open, delayDuration: 0, children: [jsx(Trigger, { type: "button", className: className, asChild: asChild, children: children }), jsxs(Content2, { className: "z-5 max-w-md rounded-lg bg-leland-gray-dark p-4 text-center text-sm text-white", side: side, sideOffset: sideOffset, children: [content, jsx(Arrow2, { className: "fill-leland-gray-dark" })] })] }));
};

export { Tooltip };
//# sourceMappingURL=tooltip.js.map
